import { Link } from 'react-router-dom';
import type { ActivitySubjectDetail } from '@shared/types/activity-feed';
import type { AccountThreadRichView } from '@shared/types/thread-work';
import { buildSubjectThreadPath } from '@/lib/thread-routes';
import { setDocumentOutput, type WorkDocumentOutput } from '@/lib/work-document-output';

/** Account identity belongs here; current actions belong to the shared result
 * action section. Do not repeat their title, rationale or command in this bar. */
export const ToolThreadContextCard = ({ detail, focusedTopicId, focusedFlowRunId, focusedVersion, focusedOutput }: {
  detail: ActivitySubjectDetail; threadState: AccountThreadRichView; focusedTopicId?: string | null; focusedFlowRunId?: string | null; focusedVersion?: string | null; focusedOutput?: WorkDocumentOutput | null;
}) => {
  const params = new URLSearchParams();
  if (focusedFlowRunId) {
    params.set('flow', focusedFlowRunId);
    if (focusedVersion && /^\d{1,10}$/.test(focusedVersion)) params.set('version', focusedVersion);
    setDocumentOutput(params, focusedOutput ?? undefined);
  } else if (focusedTopicId) params.set('topic', focusedTopicId);
  return <nav aria-label="Compte lié à cette analyse" className="flex flex-wrap items-center justify-between gap-3 border-b border-domino-cardBorder pb-4 text-sm">
  <span className="font-semibold text-domino-aubergine">{detail.subjectLabel}</span>
  <Link className="font-medium text-domino-aubergine underline underline-offset-4" to={`${buildSubjectThreadPath(detail)}${params.size ? `?${params.toString()}` : ''}`}>Ouvrir le compte</Link>
  </nav>;
};
